const getBackgroundImage = movieItem => {
    const img = {
        imgUrl: '',
        imgAlt: ''
    }
    if(!movieItem || !movieItem.images) {
        return img
    }

    if(movieItem.images.ambient && movieItem.images.ambient.url) {
        img.imgUrl = movieItem.images.ambient.url

        if(movieItem.images.ambient.alt) {
            img.imgAlt = movieItem.images.ambient.alt
        }
    } else if(movieItem.images.backgrounds && movieItem.images.backgrounds[0] && movieItem.images.backgrounds[0].url) {
        img.imgUrl = movieItem.images.backgrounds[0].url

        if(movieItem.images.backgrounds[0].alt) {
            img.imgAlt = movieItem.images.backgrounds[0].alt
        }
    }

    return img
}

export default getBackgroundImage